/**
 * Services Webapplication Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.servicesWebapplicationDetailFormatter = function (value, row) {
    let html = '';
    if (row.description) {
        html += '<textarea class="form-control" rows="3">'+row.description+'</textarea>';
    }
    return html;
};